<button class="btn btn--more" tabindex="0" title="Sluit" modal-close-btn>
    <span>Sluit</span>
    <svg class="svg-icon svg-icon--xs">
        <use href="assets/icons-ui.svg#cross-closed"></use>
    </svg>
</button>
<h2 modal-title>
    <span *ngIf="data.coverage_title === coverageIdEnum.SchadeverzekeringInzittenden">
        Schadeverzekering Inzittenden
    </span>
    <span *ngIf="data.coverage_title === coverageIdEnum.MotorSchadeOpzittenden">Schadeverzekering Opzittenden</span>
    <span *ngIf="data.coverage_title === coverageIdEnum.Pechhulp">Pechhulp</span>
    <span *ngIf="data.coverage_title === coverageIdEnum.OngevalBlijvendLetsel">Ongeval & Blijvend letsel</span>
    <span *ngIf="data.coverage_title === coverageIdEnum.OngevalOverlijden">Ongeval & Overlijden</span>
    <span *ngIf="data.coverage_title === coverageIdEnum.RechtshulpOngeval">Rechtshulp Ongeval & Verkeer</span>
    <span *ngIf="data.coverage_title === coverageIdEnum.Thuisbrengservice">Thuisbrengservice bij pech</span>
    <span *ngIf="data.coverage_title === coverageIdEnum.Aansprakelijkheidsverzekering">Aansprakelijkheid</span>
    <span *ngIf="data.coverage_title === coverageIdEnum.CaravanInboedel">Inboedel</span>
    <span *ngIf="data.coverage_title === coverageIdEnum.CaravanExtra">Extra's</span>
    <span *ngIf="data.coverage_title === coverageIdEnum.CaravanHagelEU">Hagel Europa</span>
    <span *ngIf="data.coverage_title === coverageIdEnum.CaravanHagelNL">Hagel Benelux en Duitsland</span>
</h2>
<div modal-content>
    <ins-motor-additional-coverage-info
        *ngIf="[coverageIdEnum.MotorSchadeOpzittenden].includes(data.coverage_id)"
    ></ins-motor-additional-coverage-info>
    <ng-container
        *ngIf="[coverageIdEnum.SchadeverzekeringInzittenden, coverageIdEnum.Pechhulp].includes(data.coverage_id)"
    >
        <ins-car-additional-coverage-info [coverageId]="data.coverage_id"></ins-car-additional-coverage-info>
    </ng-container>
    <ng-container *ngIf="[coverageIdEnum.Thuisbrengservice].includes(data.coverage_id)">
        <ins-bicycle-additional-coverage-info [coverageId]="data.coverage_id"></ins-bicycle-additional-coverage-info>
    </ng-container>
    <ng-container
        *ngIf="
            [
                coverageIdEnum.RechtshulpOngeval,
                coverageIdEnum.Aansprakelijkheidsverzekering,
                coverageIdEnum.OngevalBlijvendLetsel,
                coverageIdEnum.OngevalOverlijden,
            ].includes(data.coverage_id)
        "
    >
        <ins-general-additional-coverage-info [coverageId]="data.coverage_id"></ins-general-additional-coverage-info>
    </ng-container>
    <ng-container
        *ngIf="
            [
                coverageIdEnum.CaravanInboedel,
                coverageIdEnum.CaravanExtra,
                coverageIdEnum.CaravanHagelEU,
                coverageIdEnum.CaravanHagelNL,
            ].includes(data.coverage_id)
        "
    >
        <ins-caravan-additional-coverage-info [coverageId]="data.coverage_id"></ins-caravan-additional-coverage-info>
    </ng-container>
</div>
